import React from 'react';
import RotationToggle from './RotationToggle';
import PathToggle from './PathToggle';

interface SettingsModalProps {
  isOpen: boolean;
  onClose: () => void;
  clockwiseRotation: boolean;
  setClockwiseRotation: (value: boolean) => void;
  showPath: boolean;
  setShowPath: (value: boolean) => void;
  startingLevel?: number;
  setStartingLevel?: (value: number) => void;
  useScreenTapControls?: boolean;
  setUseScreenTapControls?: (value: boolean) => void;
}

const SettingsModal: React.FC<SettingsModalProps> = ({
  isOpen,
  onClose,
  clockwiseRotation,
  setClockwiseRotation,
  showPath,
  setShowPath,
  startingLevel,
  setStartingLevel,
  useScreenTapControls,
  setUseScreenTapControls
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <h2>Game Settings</h2>
        <div className="settings-controls">
          <RotationToggle clockwise={clockwiseRotation} setClockwise={setClockwiseRotation} />
          <PathToggle showPath={showPath} setShowPath={setShowPath} />
          
          {/* Starting Level Input */}
          {setStartingLevel && startingLevel !== undefined && (
            <div className="level-setting">
              <label htmlFor="starting-level">Starting Level (1-20):</label>
              <input
                id="starting-level"
                type="number"
                min="1"
                max="20"
                value={startingLevel}
                onChange={(e) => {
                  const value = parseInt(e.target.value, 10);
                  if (!isNaN(value) && value >= 1 && value <= 20) {
                    setStartingLevel(value);
                  }
                }}
              />
            </div>
          )}
          
          {/* Screen Tap Controls Toggle */}
          {setUseScreenTapControls && useScreenTapControls !== undefined && (
            <div className="control-toggle">
              <span>Screen Tap Controls: {useScreenTapControls ? 'On' : 'Off'}</span>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={useScreenTapControls}
                  onChange={() => setUseScreenTapControls(!useScreenTapControls)}
                />
                <span className="slider"></span>
              </label>
            </div>
          )}
        </div>
        <button className="close-button" onClick={onClose}>Close</button>
      </div>
    </div>
  );
};

export default SettingsModal;